import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { IsDreamHashTagActive } from "source/app/presentation/MainPanel/Dreams/HashTags/Helpers/IsDreamHashTagActive";
import { Sounds } from "source/app/services/Sound/Sounds";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import { EDA } from "motw_core/Dreams/EDreamAttribute";

export function ActivateDreamHashTag(hashTag: string) {
    Sounds.metal_clang_short_2.Play();

    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);
    const isThisHashTagActive = IsDreamHashTagActive(hashTag);

    if (isThisHashTagActive || !hashTag) {
        return;
    }

    const excludedAttributes = hashTagsService.IsProblemHashTag(hashTag)
        ? [EDA[EDA.problem]]
        : [];

    dreams.setState({
        ...clearedDreamFilters,
        excludedAttributes,
        searchText: hashTag,
    });
}
